import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { FileSVG } from '../svg/file.svg';

const FileIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <FileSVG/>
    </div>
  );
};

export { FileIcon };
